import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import useFetchMataData from "../../../Components/Hooks/useFetchMataData";
import { useFormik } from "formik";
import SearchBar from "../../../Components/Utils/SearchBar";
import {
  CancelButton,
  ClearFilterButton,
  CreateButton,
  ExportButton,
  FilterButton,
  ImportButton,
  SubmitButton,
} from "../../../Components/Utils/Buttons";
import { NuDate } from "../../../Components/Utils/Input";
import FormikSelectTwo from "../../../Components/Utils/Select";
import CustomDataTable from "../../../Components/Others/CustomDataTable";
import ImportForms from "./ImportForms";
import MultiEditForms from "./MultiEditForms";
import ModalContainer from "../../../Components/Others/ModalContainer";
import { useToast } from "../../../Components/Others/ToastServices";
import useFetchMDIndex from "../../../Components/Hooks/useFetchMDIndex";
import * as yup from "yup";
import UseGetDataSearch from "../../../Components/Hooks/useFetchDataBySearch";
import UseCatSubCatDropDown from "../../../Components/Hooks/useCategoryDropDown";
import axiosInstance from "../../../Services/axiosCommon";
import { GetAccess, GetRole } from "../../../Components/Utils/roles";
import CloseIcon from "../../../Components/Icons/Close";
import MobileFormsIndex from "../../Mobile/Forms/MobileFormsIndex";
import Pagination from "../../../Components/Utils/Pagenation";
import FileIcon from "../../../Components/Icons/FileIcon";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";


function FormsIndex() {
  const { officeId } = useParams();

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const toast = useToast();
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { value: brand } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "brand_item",
    showFilterDialog
  );
  const { value: Manufacture } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Manufacture_item",
    showFilterDialog
  );
  const { value: Unit } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Unit_item",
    showFilterDialog
  );

  const [filterProps, setFilterProps] = useState({
    category: "",
    subCategory: "",
    brand: "",
    manufacturer: "",
    underPromotion: "",
    unit: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    category: "",
    subCategory: "",
    brand: "",
    manufacturer: "",
    underPromotion: "",
    unit: "",
  });
  const clearFilter = () => {
    setParams({
      ...params,
      category: "",
      subCategory: "",
      brand: "",
      manufacturer: "",
      underPromotion: "",
      unit: "",
    });
    formik.values.category = "";
    formik.values.subCategory = "";
    formik.values.brand = "";
    formik.values.manufacturer = "";
    formik.values.underPromotion = "";
    formik.values.unit = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({
        ...params,
        category: value.category,
        subCategory: value.subCategory,
        brand: value.brand,
        manufacturer: value.manufacturer,
        underPromotion: value.underPromotion,
        unit: value.unit,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        category: "",
        subCategory: "",
        brand: "",
        manufacturer: "",
        underPromotion: "",
        unit: "",
      });
    },
  });

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/items/",
    params
  );

  const [allForm,setAllForm] = useState([])

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    try {
      // setLoading(true);
      const response = await axiosInstance.get(`/form/all-forms`);
      console.log(response.data?.data);
      setAllForm(response.data?.data);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      // setLoading(false);
    }
  };

  const [showExport, setShowExport] = useState(false);
  const [exportValue, setExportValue] = useState({
    Client: "",
    Project: "",
    salesPerson: "",
    Location: "",
    Inspector: "",
    InspectionDate: "",
    Status: "",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      try {
        const response = await axiosInstance.get(
          `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
          {
            responseType: "blob",
          }
        );

        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `CQ Report ${NuDate({
          value: new Date(),
          format: "DD-MMM-YYYY",
        })}.xlsx`;

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    },
  });
  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const { category: itemsCategory, subCategory: itemsSubCategory } =
    UseCatSubCatDropDown(
      "/category/ItemCategory",
      "ItemCategory",
      formik?.values?.category
    );
  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const handleExportClick = () => {
    setShowExport(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    console.log(e.target.checked);
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  const handleMultiDelete = (data) => {
    axiosInstance
      .delete(`items/multi-delete`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: { ids: data },
      })
      .then((res) => {
        if (res.data?.status === true) {
          if (res?.data?.not_deleted_ids.length <= 0) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          } else {
            toast.open({
              type: "warning",
              message: "Success",
              description:
                `${res.data?.msg} \n Some Products has dependenies` ||
                "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          }
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Delete UnSuccessfull",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.open({
          type: "error",
          message: "Error",
          description: "Network Error.",
        });
      });
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        console.log("I", i?.formId);
        tempArr.push(i?.formId);
      });
    setFullList(tempArr);
  }, [data]);
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
      <Breadcrumb
         items={[
          {
            name: "Forms",

          },
        

          ]} />
        <div className=" flex gap-2">
          {/* <SearchBar
            handleChange={(e) => {
              setParams({ ...params, search: e.target.value, page: 1 });
              setPage(1);
            }}
            value={params.search || searchQuery}
          /> */}
          {" "}
          <div className=" w-11 h-8"></div>
          {/* <FilterButton handleClick={() => setShowFilterDialog(true)} /> */}
          {/* 
          {filter && (
            <FilterButton handleClick={() => clearFilter()} label="Clear" />
          )} */}
          {/* <ImportButton handleClick={handleImportClick} /> */}
          {/* <ExportButton handleClick={handleExportClick} /> */}
          {/* {GetAccess("forms_create") && (
            <Link to="/forms/create">
              <CreateButton label="Forms" />
            </Link>
          )} */}
        </div>
      </div>

      <div className=" w-full h-[calc(100vh-140px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden px-4 py-2">
        <div className=" w-full h-[calc(100vh-180px)] ">
          <div className=" w-full max-h-[calc(100vh-180px)] grid grid-cols-2 md:grid-cols-8 lg:grid-cols-10 gap-4 overflow-y-auto py-4">
          {allForm &&
            allForm.map((item, i) => {
              return (
                <Link to={`/forms/view/${item?.id}`} state={{ data: item }}
                  className=" w-full h-[120px] bg-white  text-[#111537] rounded-lg shadow-lg"
                >
                  <div
                    key={i}
                    className=" w-full h-full flex flex-col py-1 px-2 justify-between items-center"
                  >
                    <FileIcon width={60} height={60} />
                    <p className=" line-clamp-3 text-xs ">
                      {item?.formName || ""}
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
        <div className=" w-full h-[25px]">
          <Pagination
            page={page}
            setPage={setPage}
            totalCount={totalCount}
            pageCount={pageCount}
            setPageCount={setPageCount}
          />
        </div>
      </div>
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[50%] max-w-[70%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex justify-start flex-wrap mb-4">
                <FormikSelectTwo
                  label="Category"
                  placeholder="Choose"
                  // Options={itemsCategory}
                  formik={formik}
                  name="category"
                  width="w-1/2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Sub-Category"
                  placeholder="Sub-Category"
                  // Options={itemsSubCategory}
                  formik={formik}
                  name="subCategory"
                  width="w-1/2 "
                />
                {/* <FormikSelectTwo
              type="text"
              label="Under Promotion?"
              placeholder="Under Promotion?"
              Options={[
                { value: "No", label: "No" },
                { value: "Yes", label: "Yes" }

              ]}
              formik={formik}
              name="underPromotion"
              width="w-1/2"
            /> */}
                <FormikSelectTwo
                  type="text"
                  label="Unit"
                  placeholder="Choose"
                  // Options={Unit}
                  formik={formik}
                  name="unit"
                  width="w-1/2"
                />
                {/* <FormikSelectTwo
                type="text"
                label="Manufaturer"
                placeholder="Choose"
                Options={Manufacture}
                formik={formik}
                name="manufacturer"
                width="w-1/2"
              /> */}
                <FormikSelectTwo
                  type="text"
                  label="Brand"
                  placeholder="Choose"
                  // Options={brand}
                  formik={formik}
                  name="brand"
                  width="w-1/2"
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (
        <ImportForms
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
      {showEdit && (
        <MultiEditForms
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => {
          handleMultiDelete(listofNumbers);
        }}
        closeModal={() => setShowDelete(false)}
      />

      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <NuDate
                      label="From "
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="fromDate"
                      width="w-1/2 "
                    />
                    <NuDate
                      label="To "
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="toDate"
                      width="w-1/2"
                    />

                    <FormikSelectTwo
                      type="text"
                      label="Sales Person"
                      placeholder="Choose"
                      Options={[]}
                      formik={ExportFormik}
                      name="salesPerson"
                      width="w-1/2"
                    />
                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default FormsIndex;
